module.exports = __webpack_public_path__ + "img/teacherResource-2.81718e07.jpg";